declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { ExternalDoctorsListController, ExternalDoctorsListRequest, SaveExternalDoctorInfoRequest } from '../../../models/actor/actor';
import { NGXToastrService } from '../../../../shared/services/toastr.service';






@Component({
  selector: 'externaldoctors',
  templateUrl: './externaldoctors.component.html',
  styleUrls: [
    './externaldoctors.component.scss']
  , animations: [routerTransition()]
})

export class ExternaldoctorsComponent implements OnInit {


  public ShowList: boolean = true;
  public AddDoctor: boolean = false;
  public EditDoctor: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  public ApiResData: ApiResponseModel;
  CurrentSaveExternalDoctorInfoRequest: SaveExternalDoctorInfoRequest;
  CurrentExternalDoctorsListController: ExternalDoctorsListController[];
  CurrentExternalDoctorsListRequest: ExternalDoctorsListRequest;

  LoadExDoctorsList() {
    this.CurrentExternalDoctorsListController = new Array<ExternalDoctorsListController>();

    this.CurrentExternalDoctorsListRequest = new ExternalDoctorsListRequest();

    //this.pdata2 = this.CurrentExternalDoctorsListController;
    this.CurrentExternalDoctorsListRequest.DoctorCode = 0;
    this.CurrentExternalDoctorsListRequest.ConditionalOperator = 10;
    this.CurrentExternalDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetExternalDoctorsListController();
  }
  GetExternalDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetExternalDoctorsListController(this.CurrentExternalDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentExternalDoctorsListController = this.ApiResData.Result;
          //this.pdata2 = this.CurrentExternalDoctorsListController;
          //this.pdata = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService, private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.LoadExDoctorsList();
    this.CurrentSaveExternalDoctorInfoRequest = new SaveExternalDoctorInfoRequest();
    this.CurrentSaveExternalDoctorInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }

  AddNewDoctor() {
    this.ShowList = false;
    this.AddDoctor = true;
    this.EditDoctor = false;
  }
  SelectedProvider: ExternalDoctorsListController;
  EditDoc(obj: any) {
    var Provider: ExternalDoctorsListController = obj;
    if (Provider != null) {
      this.SelectedProvider = null;
      this.SelectedProvider = Provider;
      this.ShowList = false;
      this.AddDoctor = false;
      this.EditDoctor = true;
    }
  }
  Cancel() {
    this.ShowList = true;
    this.AddDoctor = false;
    this.EditDoctor = false;
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  ProfileEdit() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 25;
    this.CurrentSaveExternalDoctorInfoRequest.Salutation = this.SelectedProvider.Prefix;
    this.CurrentSaveExternalDoctorInfoRequest.DoctorName = this.SelectedProvider.DisplayName;
    this.CurrentSaveExternalDoctorInfoRequest.DoctorInstitute = this.SelectedProvider.ClinicName;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = this.SelectedProvider.DocCode;
    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  RolesEdit() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 35;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = this.SelectedProvider.DocCode;
    this.CurrentSaveExternalDoctorInfoRequest.IsInchargeProvider = this.SelectedProvider.IsInchargeProvider;
    this.CurrentSaveExternalDoctorInfoRequest.IsPrimaryCareGiver = this.SelectedProvider.IsPrimaryCareGiver;
    this.CurrentSaveExternalDoctorInfoRequest.IsReferralDoctor = this.SelectedProvider.IsReferralDoctor;

    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  AddressEdit() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 45;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = this.SelectedProvider.DocCode;
    this.CurrentSaveExternalDoctorInfoRequest.AddressLine1 = this.SelectedProvider.AddressLine1;
    this.CurrentSaveExternalDoctorInfoRequest.AddressLine2 = this.SelectedProvider.AddressLine2;
    this.CurrentSaveExternalDoctorInfoRequest.City = this.SelectedProvider.City;
    this.CurrentSaveExternalDoctorInfoRequest.State = this.SelectedProvider.State;
    this.CurrentSaveExternalDoctorInfoRequest.Country = this.SelectedProvider.Country;
    this.CurrentSaveExternalDoctorInfoRequest.ZipCode = this.SelectedProvider.ZipCode;

    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  ContactEdit() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 55;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = this.SelectedProvider.DocCode;
    this.CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo = this.SelectedProvider.Telephone1;
    this.CurrentSaveExternalDoctorInfoRequest.Email = this.SelectedProvider.Email;


    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Profile() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 20;

    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = 0;
    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Roles() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 30;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = 0;


    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Address() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 40;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = 0;


    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Contact() {
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 50;
    this.CurrentSaveExternalDoctorInfoRequest.ProviderCode = 0;


    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
}
